<template>
  <div>
    <Titulo :title="titulo" />
    <template v-if="contribuicao && contribuicao.vigente && temContribuicao">
      <div class="fp-post mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--8-col-desktop mdl-grid mdl-grid--no-spacing div_grafico" style="margin:auto;">
       <GraficoMinhaContribuicao class="canvas_grafico_semi_circle" :chartdata="contribuicao.grafico"  /> 
        <div class="div_grafico_contribuicao_legenda">
          <div class="div_contribuicao_text_1">
            <dl class="dl_contribuicao_legenda">
              <dt class="dt_contribuicao_legenda">{{ contribuicao.total.nome }}</dt>
              <dd class="dd_contribuicao_text">
                <span class="span_contribuicao_legenda_1_total" :style="contribuicao.total.color">R$</span>
                <span class="span_contribuicao_legenda_2_total" :style="contribuicao.total.color">{{ contribuicao.total.valor }}</span>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <!--Participante-->
      <template v-if="contribuicao.itens.participante && contribuicao.itens.participante.valor !== 0">
        <div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--8-col-desktop mdl-grid mdl-grid--no-spacing margin_auto" style="width: 100%; display: flex; justify-content: center;">
          <div class="mdl-card__supporting-text mdl-card-container" style="width: 100%; max-width: 500px; margin: 0px !important;">
            <div class="mdl-card-container">
              <span class="span-contribuicao-titulo">Participante</span>
            </div>
            <div id="div-contribuicao-row-participante" class="div-contribuicao-row">
              <div>
                <template v-if="contribuicao.itens.participante.eventos.length > 0">
                  <template v-for="(evento, index) in contribuicao.itens.participante.eventos" :key="'participanteeventonome'+index">
                    <div class="div-contribuicao-nome" >
                      <div class="div-contribiucao-dot" :style="evento.cor"></div>
                      {{evento.nome }}
                    </div>
                     <div class="div-contribiucao-valor" style="height: 27px;" > <!-- Ver esse codigo:key="'participanteeventovalor'+index" -->
                      {{evento.valor }}
                    </div>
                  </template>
                </template>
              </div>
            </div>
            <div id="div-contribuicao-row-participante-total" class="div-contribuicao-total">
              <dl class="dl-contribuicao-total">
                <dt class="dt_contribuicao-total">Total</dt>
                <dd class="dd_contribuicao-total">{{ formatMoeda(contribuicao.itens.participante.valor, false) }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <!--Patronal-->
      <template v-if="contribuicao.itens.patronal && contribuicao.itens.patronal.valor !== 0">
        <div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--8-col-desktop mdl-grid mdl-grid--no-spacing margin_auto" style="width: 100%; display: flex; justify-content: center;">
          <div class="mdl-card__supporting-text mdl-card-container" style="width: 100%; max-width: 500px; margin: 0px !important;">
            <div class="mdl-card-container">
              <span class="span-contribuicao-titulo">Empresa</span>
            </div>
            <div id="div-contribuicao-row-patronal" class="div-contribuicao-row">
              <template v-if="contribuicao.itens.patronal.eventos.length > 0">
                <template v-for="(evento, index) in contribuicao.itens.patronal.eventos" :key="'patronaleventonome'+index">
                  <div class="div-contribuicao-nome" >
                    <div class="div-contribiucao-dot" :style="evento.cor"></div>
                    {{ evento.nome }}
                  </div>
                  <div class="div-contribiucao-valor" style="height: 27px;" >
                    {{ evento.valor }}
                  </div>
                </template>
              </template>
            </div>
            <div id="div-contribuicao-row-patronal-total" class="div-contribuicao-total">
              <dl class="dl-contribuicao-total">
                <dt class="dt_contribuicao-total">Total</dt>
                <dd class="dd_contribuicao-total">{{ formatMoeda(contribuicao.itens.patronal.valor, false) }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <!--Seguro-->
      <template v-if="contribuicao.itens.seguro && contribuicao.itens.seguro.valor !== 0">
        <div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--8-col-desktop mdl-grid mdl-grid--no-spacing margin_auto" style="width: 100%; display: flex; justify-content: center;">
          <div class="mdl-card__supporting-text mdl-card-container" style="width: 100%; max-width: 500px;margin: 0px !important;">
            <div class="mdl-card-container">
              <span class="span-contribuicao-titulo">Seguro de Renda</span>
            </div>
            <div id="div-contribuicao-row-seguro" class="div-contribuicao-row">
              <template v-if="contribuicao.itens.seguro.eventos.length > 0">
                <template v-for="(evento, index) in contribuicao.itens.seguro.eventos" :key="'seguroeventonome'+index">
                  <div class="div-contribuicao-nome" >
                    <div class="div-contribiucao-dot" :style="evento.cor"></div>
                    {{evento.nome }}
                  </div>
                  <div class="div-contribiucao-valor" style="height: 27px;" >
                    {{evento.valor }}
                  </div>
                </template>
              </template>
            </div>
            <div id="div-contribuicao-row-seguro-total" class="div-contribuicao-total">
              <dl class="dl-contribuicao-total">
                <dt class="dt_contribuicao-total">Total</dt>
                <dd class="dd_contribuicao-total">{{ formatMoeda(contribuicao.itens.seguro.valor,false) }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
      <template v-if="contribuicao.itens.administrativa && contribuicao.itens.administrativa.valor !== 0">
        <div class="mdl-cell mdl-cell--12-col mdl-cell--8-col-tablet mdl-cell--8-col-desktop mdl-grid mdl-grid--no-spacing margin_auto" style="width: 100%; display: flex; justify-content: center;">
          <div class="mdl-card__supporting-text mdl-card-container" style="width: 100%; max-width: 500px;margin: 0px !important;">
            <div class="mdl-card-container">
              <span class="span-contribuicao-titulo">Taxa Administrativa</span>
            </div>
            <div id="div-contribuicao-row-seguro" class="div-contribuicao-row">
              <template v-if="contribuicao.itens.administrativa.eventos.length > 0">
                <template v-for="(evento, index) in contribuicao.itens.administrativa.eventos" :key="'administrativaeventonome'+index">
                  <div class="div-contribuicao-nome" >
                    <div class="div-contribiucao-dot" :style="evento.cor"></div>
                    {{evento.nome }}
                  </div>
                  <div class="div-contribiucao-valor" style="height: 27px;" >
                    {{evento.valor }}
                  </div>
                </template>
              </template>
            </div>
            <div id="div-contribuicao-row-seguro-total" class="div-contribuicao-total">
              <dl class="dl-contribuicao-total">
                <dt class="dt_contribuicao-total">Total</dt>
                <dd class="dd_contribuicao-total">{{ formatMoeda(contribuicao.itens.administrativa.valor,false) }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </template>
    </template>

    <template v-if="contribuicao && contribuicao.vigente && !temContribuicao">
      <div class="div_coberturas_label" style="margin-bottom: 30px;padding-left: 5px;">
        <p>Nenhuma contribuição identificada</p>
      </div>
    </template>
    <MiniCardAcao v-if="statusParticipacao === 'Antigo'" :texto="textoMiniCard" :router="'/renda'" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Titulo from './Titulo.vue'
import GraficoMinhaContribuicao from './GraficoMinhaContribuicao.vue'
import MiniCardAcao from './MiniCardAcao.vue'
const financeiro = require('../../functions/geral/Financeiro')

export default {
  components: {
    Titulo,
    GraficoMinhaContribuicao,
    MiniCardAcao
  },
  props: {
    titulo: "",
    contratacao_contrib: 0,
  },
  computed: {
  ...mapGetters({
      participante: "participante",
      plano: "plano",
      statusParticipacao: 'statusParticipacao',
    }),
  },
  data() {
    return {
      temContribuicao: true,
      temContribuicaoParticipante: true,
      contratacaoContrib: false,
      textoMiniCard:'',
      segmento: null,
      contribuicao: {},
    }
  },
  created() {
    if ((this.participante.projetoVida || {}).contribuicao) {
      this.contribuicao = this.participante.projetoVida.contribuicao
      this.segmento = this.participante.segmento
      this.contratacaoContrib = this.contratacao_contrib
      if (this.contribuicao.itens && this.contribuicao.itens.participante) {
        let valorTotalContrib = (this.contribuicao.itens.participante.valor || 0)
        + (this.contribuicao.itens.seguro.valor || 0)
        + (this.contribuicao.itens.patronal.valor || 0)
        this.temContribuicao = valorTotalContrib > 0
        this.temContribuicaoParticipante = (this.contribuicao.itens.participante.valor || 0) > 0
      } else {
        this.temContribuicao = false
        this.temContribuicaoParticipante = false
      }
      this.statusParticipacao = this.plano.assistido
      this.preencherSegmento()
      this.setTextoMiniCard()
    }
  },
  mounted() {
    let rowParticipante = document.querySelector('#div-contribuicao-row-participante')
    if (rowParticipante) {
      let paticipanteTotal = document.querySelector('#div-contribuicao-row-participante-total')
      if (paticipanteTotal) {
        paticipanteTotal.style.height = rowParticipante.clientHeight + "px"
      }
    }
    let rowPatronal = document.querySelector('#div-contribuicao-row-patronal')
    if (rowPatronal) {
      let patronalTotal = document.querySelector('#div-contribuicao-row-patronal-total')
      if (patronalTotal) {
        patronalTotal.style.height = rowPatronal.clientHeight + "px"
      }
    }
    let rowSeguro = document.querySelector('#div-contribuicao-row-seguro')
    if (rowSeguro) {
      let seguroTotal = document.querySelector('#div-contribuicao-row-seguro-total')
      if (seguroTotal) {
        seguroTotal.style.height = rowSeguro.clientHeight + "px"
      }
    }
  },
  methods: {
    preencherSegmento() {
      this.contribuicao.total.color = `color: ${this.segmento.seg_contribuicao.total.color}`
      this.contribuicao.grafico.backgroundColor = []
      this.contribuicao.grafico.data = []
      let valor
      if((this.contribuicao.itens.participante || {}).eventos) {
        for(var i=0; i<this.contribuicao.itens.participante.eventos.length; i++) {
          if (this.contribuicao.itens.participante.eventos[i].valor !== "0,00") {
            this.contribuicao.itens.participante.eventos[i].cor = `background-color: ${this.segmento.seg_contribuicao.itens.participante[i].cor}`
            this.contribuicao.grafico.backgroundColor.push(this.segmento.seg_contribuicao.itens.participante[i].cor)
            valor = Number(this.contribuicao.itens.participante.eventos[i].valor.replace('.', '').replace(',','.'))
            if (valor) {
              this.contribuicao.grafico.data.push(valor)
            }
          }
        }
      }
      if((this.contribuicao.itens.patronal || {}).eventos) {
        for(var i=0; i<this.contribuicao.itens.patronal.eventos.length; i++) {
          if (this.contribuicao.itens.patronal.eventos[i].valor !== "0,00") {
            this.contribuicao.itens.patronal.eventos[i].cor = `background-color: ${this.segmento.seg_contribuicao.itens.patronal[i].cor}`
            this.contribuicao.grafico.backgroundColor.push(this.segmento.seg_contribuicao.itens.patronal[i].cor)
            valor = Number(this.contribuicao.itens.patronal.eventos[i].valor.replace('.', '').replace(',','.'))
            if (valor) {
              this.contribuicao.grafico.data.push(valor)
            }
          }
        }
      }
      if((this.contribuicao.itens.seguro || {}).eventos) {
        for(var i=0; i<this.contribuicao.itens.seguro.eventos.length; i++) {
          if (((this.contribuicao.itens.seguro || {}).eventos[i] || []).valor !== "0,00") {
            ((this.contribuicao.itens.seguro || {}).eventos[i] || []).cor = `background-color: ${this.segmento.seg_contribuicao.itens.seguro[i].cor}`
            this.contribuicao.grafico.backgroundColor.push(this.segmento.seg_contribuicao.itens.seguro[i].cor)
            valor = Number(this.contribuicao.itens.seguro.eventos[i].valor.replace('.', '').replace(',','.'))
            if (valor) {
              this.contribuicao.grafico.data.push(valor)
            }
          }
        }
      }
      if((this.contribuicao.itens.administrativa || {}).eventos) {
        for(var i=0; i<this.contribuicao.itens.administrativa.eventos.length; i++) {
          if (((this.contribuicao.itens.administrativa || {}).eventos[i] || []).valor !== "0,00") {
            ((this.contribuicao.itens.administrativa || {}).eventos[i] || []).cor = `background-color: ${this.segmento.seg_contribuicao.itens.administrativa[i].cor}`
            this.contribuicao.grafico.backgroundColor.push(this.segmento.seg_contribuicao.itens.administrativa[i].cor)
            valor = Number(this.contribuicao.itens.administrativa.eventos[i].valor.replace('.', '').replace(',','.'))
            if (valor) {
              this.contribuicao.grafico.data.push(valor)
            }
          }
        }
      }
    },
    setTextoMiniCard() {
      if(this.temContribuicaoParticipante && !this.contratacaoContrib) {
        this.textoMiniCard = this.contribuicao.acao.descricao
      }
      if(!this.temContribuicaoParticipante && !this.contratacaoContrib) {
        this.textoMiniCard = 'Aumente sua renda futura! Simule e contrate um valor de contribuição'
      }
      if (this.contratacaoContrib) {
        this.textoMiniCard = 'Acompanhe aqui seu pedido de aumento de contribuição'
      }
    },
    formatMoeda(value, incluiCifrao) {
      if (value === 0) {
        return '(não contratado)'
      } else if (value && value !== 0) {
        let val = financeiro.valor_to_string_formatado(value, 2, incluiCifrao, true)
        return val
      }
    }
  }
}
</script>
../../functions/geral/Financeiro